export default "__VITE_ASSET__CRyvnS2P__"